// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d0d6eedc","260":"5d84948d","300":"fcb77f62","353":"42aa0251","427":"80675cab","469":"e9d0a98b","470":"29d30d8a","563":"f78dc19b","566":"0301b3fa","670":"262cb160","809":"2642e0a2","811":"a6ec6d1c","824":"b508c4a9","929":"9110e0cc","940":"6d63b983","971":"69798f8b"}[chunkId] + ".chunk.js";
};